// project imports
import { handlerCategoryDialog } from '@api/_categories';
import { handlerLabDialog } from '@api/_labs';
import { NavActionType } from '../config';

// assets
import BuildOutlined from '@ant-design/icons/BuildOutlined';
import CalendarOutlined from '@ant-design/icons/CalendarOutlined';
import CustomerServiceOutlined from '@ant-design/icons/CustomerServiceOutlined';
import FileTextOutlined from '@ant-design/icons/FileTextOutlined';
import MessageOutlined from '@ant-design/icons/MessageOutlined';
import ShoppingCartOutlined from '@ant-design/icons/ShoppingCartOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';
import AppstoreAddOutlined from '@ant-design/icons/AppstoreAddOutlined';
import PlusOutlined from '@ant-design/icons/PlusOutlined';
import LinkOutlined from '@ant-design/icons/LinkOutlined';
import FormOutlined from '@ant-design/icons/FormOutlined';
import BarChartOutlined from '@ant-design/icons/BarChartOutlined';
import { Role } from 'src/types';
import { AppstoreOutlined } from '@ant-design/icons';

// icons
const icons = {
  AppstoreOutlined,
  BuildOutlined,
  CalendarOutlined,
  CustomerServiceOutlined,
  MessageOutlined,
  ShoppingCartOutlined,
  UserOutlined,
  AppstoreAddOutlined,
  FileTextOutlined,
  PlusOutlined,
  LinkOutlined,
  FormOutlined,
  BarChartOutlined
};

// ==============================|| MENU ITEMS - APPLICATIONS ||============================== //

const newPages = {
  id: 'group-applications',
  title: 'applications',
  icon: icons.AppstoreAddOutlined,
  type: 'group',
  roles: [Role.Admin],
  children: [
    {
      id: 'labs',
      title: 'labs',
      type: 'item',
      url: '/labs',
      icon: icons.UserOutlined,
      roles: [Role.Admin],
      actions: [
        {
          type: NavActionType.FUNCTION,
          label: 'Add Lab',
          function: () => handlerLabDialog(true),
          icon: icons.PlusOutlined
        }
      ]
    },
    {
      id: 'users',
      title: 'users',
      type: 'item',
      url: '/users',
      icon: icons.UserOutlined,
      roles: [Role.Admin]
      // actions: [
      //   {
      //     type: NavActionType.FUNCTION,
      //     label: 'Add User',
      //     function: () => handlerUserDialog(true),
      //     icon: icons.PlusOutlined
      //   }
      // ]
    },
    {
      id: 'categories',
      title: 'categories',
      type: 'item',
      url: '/categories',
      icon: icons.AppstoreOutlined,
      roles: [Role.Admin],
      actions: [
        {
          type: NavActionType.FUNCTION,
          label: 'Add Category',
          function: () => handlerCategoryDialog(true),
          icon: icons.PlusOutlined
        }
      ]
    },
    {
      id: 'pricing',
      title: 'pricing',
      type: 'item',
      url: '/pricing',
      icon: icons.FormOutlined,
      roles: [Role.Admin]
    },
    {
      id: 'usage',
      title: 'usage',
      type: 'item',
      url: '/rate-limits',
      icon: icons.BarChartOutlined,
      roles: [Role.Admin]
    }
    // {
    //   id: 'sub-categories',
    //   title: 'subcategories',
    //   type: 'item',
    //   url: '/sub-categories',
    //   icon: icons.AppstoreOutlined,
    //   roles: [Role.Admin],
    //   disabled: true,
    //   actions: [
    //     {
    //       type: NavActionType.FUNCTION,
    //       label: 'Add Sub Category',
    //       function: () => handlerSubCategoryDialog(true),
    //       icon: icons.PlusOutlined
    //     }
    //   ]
    // }
    // {
    //   id: 'customer',
    //   title: 'users',
    //   type: 'collapse',
    //   icon: icons.CustomerServiceOutlined,
    //   children: [
    //     {
    //       id: 'users',
    //       title: 'list',
    //       type: 'item',
    //       url: '/users',
    //       icon: icons.CustomerServiceOutlined,
    //       actions: [
    //         {
    //           type: NavActionType.FUNCTION,
    //           label: 'Add Customer',
    //           function: () => handlerUserDialog(true),
    //           icon: icons.PlusOutlined
    //         }
    //       ]
    //     }
    //   ]
    // }
  ]
};

export default newPages;
